import { CellClassParams, CellStyle } from "ag-grid-community";

// Private - formatter methods
const bold13F = (params: CellClassParams, field: string): CellStyle => ({
  ...(params.data[field] === "13f" ? { fontWeight: "bold" } : {}),
});

const assignColorToChangeNumber = (params: CellClassParams, field: string): CellStyle => {
  const colors = { black: "#000000", green: "#0DA084", red: "#EC6A4C" };
  const { data } = params;
  const style: CellStyle = {
    color: colors.black,
  };
  if (data[field] > 0) {
    style.color = colors.green;
  } else if (data[field] < 0) {
    style.color = colors.red;
  }
  return style;
};

export const boldCellStyleFormatter = (params: CellClassParams): CellStyle => ({
  ...bold13F(params, "SOURCE"),
});

export const colorToChangeCellStyleFormatter = (params: CellClassParams, field: string): CellStyle => ({
  ...assignColorToChangeNumber(params, field),
});

export const colorAndBoldCellStyleFormatter = (params: CellClassParams, field: string): CellStyle => ({
  ...assignColorToChangeNumber(params, field),
  ...bold13F(params, "SOURCE"),
});
